export const DIALOG_MODES = {
  BASE: 0,
  INTERNAL_FORM: 1,
  EXTERNAL_FORM_SUBMIT: 2
};
